"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const vendorBillItem_styles_1 = require("./vendorBillItem.styles");
const VendorBillItem = ({ icon, title, price, green = false }) => {
    const { item, greenText, text } = (0, vendorBillItem_styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, md: 12, xs: 12, container: true, justifyContent: "space-between", sx: Object.assign(Object.assign({}, item), (green && greenText)), children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, sx: text, children: [icon && icon, title] }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: price })] }));
};
exports.default = VendorBillItem;
